import { api } from './api';

// Get portal options (SAML/LDAP etc)
export const getPortalOptions = async (portalId) => {
  try {
    const response = await api.get(`/api/portals/${portalId}/options`);
    if (response.data.status === 'error') {
      throw new Error(response.data.error || 'Failed to fetch portal options');
    }
    return response.data;
  } catch (error) {
    console.error('Failed to fetch portal options:', error);
    throw error.response?.data || error;
  }
};

// Update portal options (SAML/LDAP etc)
export const updatePortalOptions = async (portalId, options) => {
  try {
    const response = await api.put(`/api/portals/${portalId}/options`, options);
    if (response.data.status === 'error') {
      throw new Error(response.data.error || 'Failed to update portal options');
    }
    return response.data;
  } catch (error) {
    console.error('Failed to update portal options:', error);
    throw error.response?.data || error;
  }
};
